import { DatePicker, Form, Modal, Popover, Select, message, Input, Pagination, Drawer, Table } from "antd";

import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AssetStore } from "../../../assets/AssetsStore";
import styles from "./index.module.scss";
import { Radio } from "antd";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { ADMIN_USER, USER_DATA } from "../../../constants/const";
import { getFromLocalStorage } from "../../../Helpers/localStorageHelper";
import moment from "moment";
import { createTimeSlots } from "../../../Helpers/DateHelpers";
import { createDropdownValues } from "../../../Helpers/helperFunctions";
import Assets from "../../Layout/Assets";
import AdminAppointmentFilters from "../../RequestFilter";

import { FETCH_ADMIN_DASHBOARD_REPORT, fetch_doctors_list, acceptrejectrequest, FETCH_REQUEST_DASHBOARD_REPORT } from "../../../actions/ClinicAdminAction";
import { INTERBRANCH_MODAL } from "../../../actions/type";
import EmptyTableData from "../../Common/EmptyTableData/EmptyTableData";
import { SearchOutlined } from "@ant-design/icons";
import CustomeModal from "../../CustomeModal/CustomeModal";
import TodaysReportModalContent from "../../RequestModalContent/RequestModalContent";
import { downloadAppointmentRequestreport } from "../../../actions/InterbranchAdminActions";
import { toast } from "react-toastify";
import { Card } from "react-bootstrap";
import { DownOutlined } from "@ant-design/icons";
import { fetchgangaSpeciality, fetchallSpeciality} from "../../../actions/SpecialityListingAction";
import { PuffLoader } from "react-spinners";

const RadioGroup = Radio.Group;

function RequestedAppointments() {
	const [isLoaded, setIsLoaded] = useState(false);
	let [appointments, setAppointments] = useState([]);
	let [acceptModal, setAcceptModal] = useState(false);
	let [reassignModal, setReassignModal] = useState(false);
	let [rejectModal, setRejectModal] = useState(false);
	let [inprogressModal, setInprogressModal] = useState(false);
	let [reAssignData, setReassignData] = useState({});
	let [requestedData, setRequestedData] = useState({});
	let [processdone, setProcessdone] = useState(false);
	let [activePage, setActivePage] = useState(1);
	const [userType, setUserType] = useState();
	let [loader, setLoader] = useState(true);
	let [totalnoofpages, setTotalnoofpages] = useState(0);
	let [isInitial, setinitial] = useState(true);
	let [isModelOpen, setModelOpen] = useState(false);
	let [selectedDate, setSelectedDate] = useState({ from: null, to: null });
	const [selectedStatus, setSelectedStatus] = useState("ALL");
	const userData = JSON.parse(localStorage.getItem("userData"));
	const [filterAppointments, setFilterAppointments] = useState([]);
	const [filteredTotalPages, setFilteredTotalPages] = useState(0);
	const [pendingCount, setPendingCount] = useState(0);
	const [rejectedCount, setRejectedCount] = useState(0);
	const [inprogresscount, setInprogresscount] = useState(0);
	const [callRefresh, setCallRefresh] = useState(false);
	const [fliterby, setFiltertype] = useState("byStatus");
	let [isDownloading, setIsDownloading] = useState(false);
	let [isDownloadingenable, setIsDownloadingenable] = useState(false);
	useEffect(() => {
		checUser();
	}, []);

	const { Option } = Select;

	const tableRef = useRef();
	const dispatch = useDispatch();
	const [departments, setDepartments] = useState([]);
	const [speciality, setSpeciality] = useState([]);

	useEffect(() => {
		dispatch(fetchgangaSpeciality("Others")).then((res) => {
			if (res) {
				console.log("department", res);
				const options = res.map((item) => ({
					id: item.specialityId,
					name: item.subspecialityName,
				}));
				setDepartments(options);
			}
		});

		dispatch(fetchallSpeciality("")).then((res) => {
			if (res) {
				console.log("department", res);
				const options = res.map((item) => ({
					id: item.SpecialityId,
					name: item.specialityName,
				}));
				setSpeciality(options);
			}
		});
	}, []);
	console.log("departmentsss", departments);

	console.log("totalNumberOfPages", totalnoofpages);

	useEffect(() => {
		setLoader(true);
		dispatch(FETCH_ADMIN_DASHBOARD_REPORT(userData.clinicId, 0, selectedStatus, fliterby)).then((res) => {
			console.log("res", res);
			setLoader(false);
			setAppointments(res?.data);
			setFilterAppointments(res?.data);
			//setFilteredTotalPages(res?.totalNumberOfPages);
			setIsDownloadingenable(res?.data.length > 0 ? true : false);
			setIsLoaded(true);
			if (selectedStatus === "Pending") {
				setPendingCount(res?.pendingCount);
				setCallRefresh(true);
			}
			if (selectedStatus === "Rejected") {
				setRejectedCount(res?.rejectedCount);
				setCallRefresh(true);
			}
			if (selectedStatus === "ALL") {
				setPendingCount(res?.pendingCount);
				setRejectedCount(res?.rejectedCount);
				setInprogresscount(res?.InprogressCount);
				setCallRefresh(true);
			}
			if (fliterby != "byStatus") {
				if (res?.totalNumberOfPages != undefined) {
					//   totalnoofpages=res.data.data.totalNumberOfPages;
					setTotalnoofpages(res?.totalNumberOfPages);
				}
				setPendingCount(res?.pendingCount);
				setRejectedCount(res?.rejectedCount);
				setInprogresscount(res?.InprogressCount);
				setCallRefresh(true);
			} else {
				if (res?.totalNumberOfPages != undefined) {
					//   totalnoofpages=res.data.data.totalNumberOfPages;
					setTotalnoofpages(res?.totalNumberOfPages);
				}
			}
		});
	}, [appointments?.appointmentId, selectedStatus]);

	console.log("selectedStatus", selectedStatus);
	console.log("fliterby", fliterby);

	console.log("totalnoofpages", totalnoofpages);
	let resetfilter = (e) => {
		setLoader(true);
		dispatch(FETCH_ADMIN_DASHBOARD_REPORT(userData.clinicId, 0, selectedStatus, fliterby)).then((res) => {
			console.log("res", res);
			setLoader(false);
			setAppointments(res?.data);
			setFilterAppointments(res?.data);
			setFilteredTotalPages(res?.totalNumberOfPages > 4 ? res?.totalNumberOfPages - 3 : res?.totalNumberOfPages);
			if (res?.totalNumberOfPages != undefined) {
				//   totalnoofpages=res.data.data.totalNumberOfPages;
				setTotalnoofpages(res?.totalNumberOfPages > 4 ? res?.totalNumberOfPages - 3 : res?.totalNumberOfPages);
			}
			if (selectedStatus === "Pending") {
				setPendingCount(res?.pendingCount);
				setCallRefresh(true);
			}
			if (selectedStatus === "Rejected") {
				setRejectedCount(res?.rejectedCount);
				setCallRefresh(true);
			}

			if (selectedStatus === "ALL") {
				setPendingCount(res?.pendingCount);
				setRejectedCount(res?.rejectedCount);
				setCallRefresh(true);
			}
		});
	};

	let handlePaginationChange = (e) => {
		setLoader(true);

		// setLoader(true)
		dispatch(FETCH_ADMIN_DASHBOARD_REPORT(userData.clinicId, e - 1, selectedStatus, fliterby)).then((res) => {
			console.log("**************fetchAppointmentHistory API result ==> ", res);
			setLoader(false);
			setAppointments(res?.data);
			setFilterAppointments(res?.data);
			// setFilteredTotalPages(res?.totalNumberOfPages-3);
		});
		setActivePage(e);
		tableRef.current.scrollTo(0, 0); // Scroll to top
	};

	const toggleAcceptModal = (flag) => setAcceptModal(flag ? flag : false);
	const toggleReassignModal = (flag) => setReassignModal(flag ? flag : false);
	const toggleRejectModal = (flag) => setRejectModal(flag ? flag : false);
	const toggleInprogressModal = (flag) => setInprogressModal(flag ? flag : false);

	let checUser = async () => {
		getFromLocalStorage(USER_DATA).then((res) => {
			setUserType(JSON.parse(res).userType);
			//    setUserId(JSON.parse(res).userId);
		});
	};

	if (processdone) {
		dispatch(FETCH_ADMIN_DASHBOARD_REPORT(userData.clinicId, activePage - 1)).then((res) => {
			console.log("processdoneres", res);
			setLoader(false);
			setAppointments(res?.data);
			setProcessdone(false);
		});
	}
	let handleTableClick = (eachRow) => {
		dispatch({
			type: INTERBRANCH_MODAL,
			payload: eachRow,
		});
		localStorage.setItem("reqid", eachRow);
		setModelOpen(true);
		// dispatch({
		//   type: INTERBRANCH_MODAL,
		//   payload: {
		//     name: "requestmodal",
		//     value: true,
		//   },
		// });

		// dispatch(setModalRedux({
		//     name: "todaysReportModal",
		//     value: true
		// }))
	};

	function refreshDataWithoutPageChange() {
		//This function is only for refresh data without pagination change. Eg: After accepting the request from modal
		console.log("refreshDataWithoutPageChange");
		localStorage.removeItem("reqid");
		setLoader(true);
		//Passing active pagination from the state as "activePage"
		dispatch(FETCH_ADMIN_DASHBOARD_REPORT(userData.clinicId, activePage - 1, selectedStatus, fliterby)).then((res) => {
			setAppointments(res?.data);
			setLoader(false);
		});
	}

	function handleDrawerClose() {
		console.log("handleDrawerClose");
		setModelOpen(false);
		// refreshDataWithoutPageChange();
		dispatch(FETCH_ADMIN_DASHBOARD_REPORT(userData.clinicId, activePage - 1, selectedStatus, fliterby)).then((res) => {
			setAppointments(res?.data);
			setPendingCount(res?.pendingCount);
			setRejectedCount(res?.rejectedCount);
			setInprogresscount(res?.InprogressCount);
		});
	}
	console.log("process", processdone);

	let downloadReport = () => {
		console.log("Downloading report.........");
		setIsDownloading(true);
		dispatch(
			downloadAppointmentRequestreport({
				fromDate: selectedDate?.from,
				toDate: selectedDate?.to,
				filterBy: selectedStatus,
				filterType: fliterby,
			})
		).then((res) => {
			console.log("Response:", res);
			if (res) {
				console.log("Download URL:", res);
				window.open(res, "_blank");
				setIsDownloading(false);
				toast.success("Downloaded Successfully!");
			}
		});
	};

	const handleStatusFilterChange = (value) => {
		console.log("Selected Status:", value);
		setSelectedStatus(value?.value);
		setFiltertype(value?.name);
		setActivePage(1);
	};
	console.log("selectedStatus", selectedStatus);

	const handleresetfilterFilterChange = (value) => {
		console.log("Selected Status:", value);
		setSelectedStatus("ALL");
		setFiltertype("byStatus");
		setActivePage(1);
	};

	const options = [
		{ value: "ALL", label: "ALL" },
		{ value: "Pending", label: "Pending" },
		{ value: "Rejected", label: "Rejected" },
		{ value: "Inprogress", label: "In-Progress" },
	];

	const filterAppointmentsByStatus = () => {
		if (selectedStatus === "ALL") {
			return appointments;
		} else {
			return appointments?.filter((appointment) => {
				if (selectedStatus === "Pending") {
					return appointment.appointmentStatus === "Requested by Admin";
				} else if (selectedStatus === "Rejected") {
					return appointment.appointmentStatus !== "Requested by Admin";
				}
			});
		}
	};
	console.log("status", selectedStatus);

	return (
		<>
			<div className={styles.requestedAppointmentsWrap}>
				<div className={styles.header}>
					<Card className={styles.card}>
						{selectedStatus === "Pending" && (
							<>
								<span className={styles.span}>
									Pending
									<div className={styles.div}>{pendingCount} Appointments</div>
								</span>
							</>
						)}
						{selectedStatus === "Rejected" && (
							<>
								<span className={styles.span}>
									Rejected
									<div className={styles.div}>{rejectedCount} Appointments</div>
								</span>
							</>
						)}
						{selectedStatus === "Inprogress" && (
							<>
								<span className={styles.span}>
									In Progress
									<div className={styles.div}>{inprogresscount} Appointments</div>
								</span>
							</>
						)}
						{selectedStatus === "ALL" && (
							<div style={{ display: "flex", height: "100%" }}>
								<span className={styles.span}>
									{" "}
									Pending
									<div className={styles.div}>{pendingCount} Appointments</div>
								</span>
								<div className={styles.border}></div>
								<span className={styles.span}>
									{" "}
									Rejected
									<div className={styles.div}>{rejectedCount} Appointments</div>
								</span>
								<div className={styles.border}></div>
								<span className={styles.span}>
									{" "}
									In Progress
									<div className={styles.div}>{inprogresscount} Appointments</div>
								</span>
							</div>
						)}

						{fliterby != "byStatus" && (
							<div style={{ display: "flex" }}>
								<span className={styles.span}>
									{" "}
									Pending
									<div className={styles.div}>{pendingCount} Appointments</div>
								</span>
								<div className={styles.border}></div>
								<span className={styles.span}>
									{" "}
									Rejected
									<div className={styles.div}>{rejectedCount} Appointments</div>
								</span>
								<div className={styles.border}></div>
								<span className={styles.span}>
									{" "}
									In Progress
									<div className={styles.div}>{inprogresscount} Appointments</div>
								</span>
							</div>
						)}
					</Card>

					<AdminAppointmentFilters
						onDownloadRequest={(downloadParams) => {
							console.log("🚀 ~ TodaysReport ~ downloadParams:", downloadParams);
							downloadReport(downloadParams);
						}}
						onFilterSubmit={(filterParams) => {
							console.log("filterParams:", filterParams);
							handleStatusFilterChange(filterParams);
						}}
						onResetfilter={handleresetfilterFilterChange}
						downloading={isDownloading}
						downloadavailable={isDownloadingenable}
						departments={departments}
						speciality={speciality}
					/>
				</div>

				<Table
					loading={{
						indicator: <PuffLoader color={"#208ce1"} loading={true} size={40} />,
						className: styles.loaderWrap,
						spinning: loader,
					}}
					key={activePage}
					ref={tableRef}
					// loading={loader}
					scroll={{
						x: "max-content",
						y: "calc(100vh - 360px)",
					}}
					pagination={false}
					columns={[
						{
							title: "Request Id",
							dataIndex: "appointmentId",
							key: "appointmentId",
							render: (text) => <span style={{ color: "#40a9ff" }}>{text}</span>,
						},
						{
							title: "Request Date",
							dataIndex: "requesteddate",
							key: "requesteddate",
						},
						{
							title: "Department Name",
							dataIndex: "specialityName",
							key: "specialityName",
							//render: (text) => text || "NA",
							render: (_, record) => (
								<div style={{ display: "flex", flexDirection: "column" }}>
									<span>{record.specialityName}</span>
									<span>({ record.mainSpeciality })</span>
									</div>
							)
						},
						{
							title: "Patient Name",
							key: "patientInfo",
							render: (_, record) => (
								<div style={{ display: "flex", flexDirection: "column" }}>
									<span>{record.patientname}</span>
									<span>
										({record.patientGender && `${record.patientGender}, `}
										{(() => {
											const dob = record.patientDob;
											const dobDate = new Date(dob);
											const currentDate = new Date();
											const ageInMonths = Math.floor((currentDate - dobDate) / (1000 * 60 * 60 * 24 * 30.4375));
											const ageInYears = Math.floor(ageInMonths / 12);

											if (ageInMonths < 1) return `1 month`;
											if (ageInMonths < 12) return `${ageInMonths} months`;
											return `${ageInYears} years`;
										})()}
										)
									</span>
								</div>
							),
						},
						...(userType === ADMIN_USER
							? [
									{
										title: "Hospital Name",
										key: "hospitalName",
										render: () => "Ganga Hospital",
									},
							  ]
							: []),
						{
							title: "Hospital Id",
							key: "hospitalId",
							render: (_, record) => (record.hospitalId !== undefined && record.hospitalId !== "" ? record.hospitalId : "New Patient"),
						},
						{
							title: "Status",
							key: "appointmentStatus",
							fixed: "right",
							render: (_, record) => {
								if (record.appointmentStatus === "Requested by Admin" || record.appointmentStatus === "Requested") {
									return <span className={`${styles.appointmentStatus} ${styles.pending}`}>Pending</span>;
								} else if (record.appointmentStatus === "Inprogress") {
									return <span className={`${styles.appointmentStatus} ${styles.inprogress}`}>In Progress</span>;
								} else {
									return <span className={`${styles.appointmentStatus} ${styles.error}`}>Rejected</span>;
								}
							},
						},
					]}
					// dataSource={[]}
					dataSource={appointments}
					rowKey="appointmentId"
					onRow={(record) => ({
						onClick: () => handleTableClick(record.appointmentId),
					})}
					locale={{
						emptyText: !isLoaded || loader ? " " : <EmptyTableData haveButton={false} text={isInitial && "LOOKS LIKE NO REQUEST HAVE BEEN CREATED YET"} caption={""} />,
					}}
				/>

				{appointments?.length > 0 && totalnoofpages > 1 && (
					<div className="pagination-container paginationWrap" text={totalnoofpages}>
						<Pagination showSizeChanger={false} onChange={handlePaginationChange} defaultCurrent={activePage} total={totalnoofpages * 10} hideOnSinglePage={true} current={activePage} />
					</div>
				)}

				<AcceptModal open={acceptModal} togggle={toggleAcceptModal} onOk={() => {}} appointmentData={requestedData} setProcessdone={setProcessdone} />
				<AcceptModal isReassign setReassignData={setReassignData} reAssignData={reAssignData} open={reassignModal} togggle={toggleReassignModal} onOk={() => {}} appointmentData={requestedData} setProcessdone={setProcessdone} />
				<RejectModal open={rejectModal} togggle={toggleRejectModal} appointmentData={requestedData} setProcessdone={setProcessdone} />
				<RejectModal open={inprogressModal} togggle={toggleInprogressModal} appointmentData={requestedData} setProcessdone={setProcessdone} />
			</div>

			<Drawer className={styles.appointmentDetailsDrawer} closeIcon={false} title={false} key={isModelOpen ? "1" : "2"} placement="right" onClose={handleDrawerClose} open={isModelOpen}>
				<TodaysReportModalContent handleTableRefresh={refreshDataWithoutPageChange} />
			</Drawer>
			{/* <CustomeModal
        width={700}
        state={isModelOpen}
        modalName="requestmodal"
        component={}
        isRight
      /> */}
		</>
	);
}

export default RequestedAppointments;

const AcceptModal = ({ open, togggle, isReassign, reAssignData, setReassignData, appointmentData, setProcessdone, setAppointments }) => {
	let [timeSlots, setTimeSlots] = useState();
	const [form] = Form.useForm();
	let [doctors, setDoctors] = useState();
	const dispatch = useDispatch();
	const [userId, setUserId] = useState();

	useEffect(() => {
		checUser();
		console.log("requestedData", appointmentData);
		if (appointmentData != undefined) {
			console.log("requestedData", appointmentData.doctorId);
			// dispatch(
			//   fetch_doctors_list("Ganga Hospital", appointmentData.doctorId)
			// ).then((res) => {
			//   console.log("res", res);
			//   setDoctors(res);
			// });
		} else {
			console.log("requestedData", appointmentData);
		}
		if (isReassign && reAssignData) {
			form.setFieldsValue({
				appointmentDate: moment(reAssignData?.date),
				appointmentTime: "09:00 am",
				doctorName: doctors,
			});
		}
	}, [open]);

	useEffect(() => {
		if (!open) {
			form.resetFields();
		}
	}, [open]);

	let checUser = async () => {
		getFromLocalStorage(USER_DATA).then((res) => {
			setUserId(JSON.parse(res).userId);
		});
	};
	const getdoctorslis = () => {
		let doctorslist = [];
		if (doctors != undefined && doctors.length > 0) {
			doctors.map((eachAppointment, key) => {
				doctorslist.push({
					value: eachAppointment.doctorName,
					option: eachAppointment.doctorId,
				});
			});
		}
		return doctorslist;
	};

	const getConditionalText = (key) => {
		switch (key) {
			case "formCaption":
				return isReassign ? "Select" : "Confirm";
			case "submitText":
				return isReassign ? "Reassign" : "Assign";
			case "successMessage":
				return isReassign ? "Reassigned" : "Assigned";
			default:
				break;
		}
	};

	function handleAppointmentDateChange(e) {
		console.log("e", e);
		if (e != null) {
			let _timeSlots = createTimeSlots(e);
			setTimeSlots(_timeSlots);
		} else {
			setTimeSlots([]);
		}
	}

	function handleFormFinish(data) {
		//togggle(false);
		console.log("data", data);
		const momentObject = moment(data.appointmentDate, "DD-MMM-YYYY");
		console.log("momentObject", momentObject.format("DD-MMM-YYYY") + " " + data.appointmentTime);
		console.log("appointmentData", appointmentData.appointmentId);

		let param = {
			process: "accept",
			appointmentId: appointmentData.appointmentId,
			UserId: userId,
			doctorId: data.doctorName,
			alternateDate: momentObject.format("DD-MMM-YYYY") + " " + data.appointmentTime,
		};

		dispatch(acceptrejectrequest(param)).then((res) => {
			console.log("res", res);
			if (res.info === "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience.") {
				message.success(`Time slot already chosen by some other person. Please try with different slot, Sorry for the inconvenience.`);
			} else {
				message.success(`Appointment ${getConditionalText("successMessage")} successfully`);
				togggle(false);
				setProcessdone(true);
				setAppointments(res?.data);
			}
		});
	}
	const { Option } = Select;

	return (
		<Modal className={`${styles.customModal} ${styles.customModalAccept}`} footer={false} closeIcon={<></>} header={null} open={open}>
			<Form form={form} onFinish={handleFormFinish} className={styles.accept_form}>
				<div className={styles.modalBody}>
					<div className={styles.formItem}>
						<div className={styles.formItemcaption}>
							{getConditionalText("formCaption")} the appointment date <span className={styles.mandatory}>*</span>
						</div>
						<div className={styles.formItemContent}>
							<Form.Item
								name="appointmentDate"
								rules={[
									{
										required: true,
										message: "*Please Select Date",
									},
								]}
							>
								<DatePicker format="DD-MMM-YYYY" disabledDate={(current) => current.isBefore(moment().subtract(1, "day"))} onChange={handleAppointmentDateChange} />
							</Form.Item>
						</div>
					</div>

					<div className={styles.formItem}>
						<div className={styles.formItemcaption}>
							{getConditionalText("formCaption")} the appointment time <span className={styles.mandatory}>*</span>
						</div>
						<div className={styles.formItemContent}>
							<Form.Item
								name="appointmentTime"
								rules={[
									{
										required: true,
										message: "*Please Select Time",
									},
								]}
							>
								<Select placeholder="Select Time">
									options={createDropdownValues(timeSlots)}
									allowClear
								</Select>
							</Form.Item>
						</div>
					</div>

					<div className={styles.formItem}>
						<div className={styles.formItemcaption}>
							{getConditionalText("formCaption")} the doctor <span className={styles.mandatory}>*</span>
						</div>
						<div className={styles.formItemContent}>
							<Form.Item
								name="doctorName"
								rules={[
									{
										required: true,
										message: "*Please Select Doctor",
									},
								]}
							>
								{/* <Select
                  allowClear
                  defaultValue="Select Doctor"
                  //options={getdoctorslis()}
                  {doctors.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                    doctorslist.push({ value: eachAppointment.doctorName, option: eachAppointment.doctorName });
                  placeholder="Select Doctor"
                /> */}
								<Select placeholder="Select Doctor">
									{doctors != undefined &&
										doctors.map((option) => (
											<Option key={option.doctorId} value={option.doctorId}>
												{option.doctorName}
											</Option>
										))}
								</Select>
							</Form.Item>
						</div>
					</div>
				</div>

				<div className={styles.modalFooter}>
					<button
						type="button"
						className={styles.closeModalBtn}
						onClick={() => {
							togggle(false);
						}}
					>
						Close
					</button>
					<button type="submit" className={styles.acceptModalBtn}>
						{getConditionalText("submitText")}
					</button>
				</div>
			</Form>
		</Modal>
	);
};

const RejectModal = ({ open, togggle, appointmentData, setProcessdone, refreshDataWithoutPageChange }) => {
	const options = [
		{
			label: "Multiple appointment requests",
			value: "Multiple appointment requests",
		},
		{
			label: "Referred to another Doctor/Specialist",
			value: "Referred to another Doctor/Specialist",
		},
		{
			label: "Met the doctor/Specialist in person",
			value: "Met the doctor/Specialist in person",
		},
		{ label: "No consultation required", value: "No consultation required" },
		{ label: "Doctor is not available", value: "Doctor is not available" },
		{ label: "Doctor is on a vacation", value: "Doctor is on a vacation" },
	];

	const [value, setValue] = useState();
	const [error, setError] = useState();
	const dispatch = useDispatch();

	function onChange(e) {
		console.log("onChange", e.target.value);
		setValue(e.target.value);
		if (!e.target.value) {
			setError(true);
		} else {
			setError(false);
		}
	}

	function handleRejectSubmit() {
		console.log("handleRejectSubmit", value);
		if (!value) {
			setError(true);
		} else {
			let param = {
				process: "cancel",
				appointmentId: appointmentData.appointmentId,
				// "UserId":userId,
				reason: value,
			};
			console.log("param", param);

			dispatch(acceptrejectrequest(param)).then((res) => {
				console.log("res", res);
				togggle(false);
				setProcessdone(true);
				refreshDataWithoutPageChange();
			});
			message.success(`Appointment rejected`);
			setError(false);
			togggle(false);
			setValue("");
		}
	}

	return (
		<Modal className={`${styles.customModal} ${styles.customModalReject}`} footer={false} closeIcon={<></>} header={null} open={open}>
			<div className={styles.modalBody}>
				<h5>Select reason for rejection !</h5>

				<RadioGroup options={options} onChange={onChange} value={value} />
				{error ? <span className={styles.validationError}>*Please select reason !!!</span> : ""}
			</div>

			<div className={styles.modalFooter}>
				<button
					className={styles.closeModalBtn}
					onClick={() => {
						togggle(false);
						setValue("");
					}}
				>
					Close
				</button>
				<button className={styles.rejectModalBtn} onClick={handleRejectSubmit}>
					Reject
				</button>
			</div>
		</Modal>
	);
};
// const ActionButtons = ({ onAccept, onReject }) => {
// 	return (
// 		<div className={styles.actioButtonsWrap}>
// 			<button onClick={onAccept} className={styles.acceptBtn}>
// 				<img src={AssetStore.checkRound} alt="" />
// 				Accept
// 			</button>
// 			<button onClick={onReject} className={styles.rejectBtn}>
// 				<img src={AssetStore.closeRound} alt="" />
// 				Reject
// 			</button>
// 		</div>
// 	);
// };

// const RejectionStatus = ({ reason }) => {
// 	const content = <span>Reason: {reason}</span>;

// 	return (
// 		<div className={styles.rejectedStatusWrap}>
// 			<span>
// 				Rejected by Admin
// 				<Popover placement="left" content={content} title={false}>
// 					<img src={Assets.info} alt="" />
// 				</Popover>
// 			</span>
// 		</div>
// 	);
// };
// const AcceptStatus = ({ onReassign, appointmentDate }) => {
// 	const content = (
// 		<>
// 			<div>Date & Time: {appointmentDate}</div>
// 			{/* <div>Time: 10:30 AM</div> */}
// 		</>
// 	);
// 	return (
// 		<div className={styles.acceptedStatusWrap}>
// 			<span>
// 				Accepted by Admin
// 				<Popover placement="left" content={content} title={false}>
// 					<img src={Assets.info} alt="" />
// 				</Popover>
// 			</span>

// 			{/* <button onClick={onReassign} className={styles.reassignButton}>
//         Reassign
//       </button> */}
// 		</div>
// 	);
// };
